
export enum SystemWorkOrderStatus {
    Open = 'Open',
    InProgress = 'In Progress',
    OnHold = 'On Hold',
    Completed = 'Completed',
    Finalised = 'Finalised',
    Closed = 'Closed',
    Canceled = 'Canceled'
}

//Status values that are still considered 'Open'
export const OpenSystemWorkOrderStatusValues = [SystemWorkOrderStatus.Open, SystemWorkOrderStatus.InProgress, SystemWorkOrderStatus.OnHold];

